import React from "react";
import { Box, Typography, alpha } from "@mui/material";

export interface StatCardProps {
  icon: React.ReactElement;
  label: string;
  value: React.ReactNode;
  /** Accent color used for the icon halo + hover border. */
  color?: string;
  /** Optional click handler (renders the card as a button affordance). */
  onClick?: () => void;
}

const NAVY = "#0B1E2D";
const GOLD = "#058dd0";
const BORDER = "#E5E7EB";
const TEXT_SECONDARY = "#6B7280";

export default function StatCard({ icon, label, value, color = NAVY, onClick }: StatCardProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2,
        borderRadius: "12px",
        bgcolor: "background.paper",
        border: `1px solid ${BORDER}`,
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 24px rgba(11,30,45,0.10)",
          borderColor: alpha(GOLD, 0.45),
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha(color, 0.12),
          }}
        >
          {React.cloneElement(icon, { sx: { fontSize: 16, color } })}
        </Box>
        <Typography fontSize={10} fontWeight={700} color={TEXT_SECONDARY} textTransform="uppercase" letterSpacing="0.06em">
          {label}
        </Typography>
      </Box>
      <Typography fontSize={20} fontWeight={800} color={NAVY}>
        {value}
      </Typography>
    </Box>
  );
}
